module.exports = __webpack_public_path__ + "static/media/dark1Single.6ffdcc5d.JPG";